import { Injectable } from '@angular/core';
import { ContractDTO, RequestMaterialDTO } from '../../api/plyca-dtos-v2';
import { MasterDataDTO } from '../../api/plyca-dtos';

@Injectable()
export class ContractValidations {

  // Sin segunda licitación
  public static isWithOutSecondBinding(data: MasterDataDTO) {
    let resultado = false;
    if (data != null) {
      resultado = data.identifier === '0<>TIPO_LICITACION';
    }
    return resultado;
  }

  // Con segunda licitación
  public static isWithSecondBinding(data: MasterDataDTO) {
    let resultado = false;
    if (data != null) {
      resultado = data.identifier === '1<>TIPO_LICITACION';
    }
    return resultado;
  }

  // Licitación de tipo Mixto
  public static isMixedBinding(data: MasterDataDTO) {
    let resultado = false;
    if (data != null) {
      resultado = data.identifier === '2<>TIPO_LICITACION';
    }
    return resultado;
  }

  // Licitación automática
  public static isAutomaticBinding(data: MasterDataDTO) {
    let resultado = false;
    if (data != null) {
      resultado = data.identifier === '3<>TIPO_LICITACION';
    }
    return resultado;
  }

  // esMenor = modoProc.equals("M")
  public static isMinorContrat(model: any) {
    let isModesMinor = false;
    if (model.type) {
      isModesMinor = model.type.identifier === 'M<>PROCEDIMIENTOSCONTRA';
      if (model.type.properties) {
        isModesMinor =
          isModesMinor || model.type.properties['MODO'] === 'M'
      }
    }
    return isModesMinor;
  }

  // Es sistema de homologación ("DSH")
  public static isHomologationSystem(model: any) {
    let isHomologationSystem = false;
    if (model.type) {
      isHomologationSystem = model.type.identifier === 'DSH<>PROCEDIMIENTOSCONTRA';
      if (model.type.properties) {
        isHomologationSystem = isHomologationSystem || model.type.properties['MODO'] === 'DSH';
      }
    }
    return isHomologationSystem;
  }

  private static isOpenContrat(model: any) {
    if (model.type) {
      let isModesOpenContract =
        model.type.identifier === 'A<>PROCEDIMIENTOSCONTRA';
      if (model.type.properties) {
        isModesOpenContract =
          isModesOpenContract || model.type.properties['MODO'] === 'A'
      }
      let isOpen =
        isModesOpenContract ||
        (ContractValidations.isDesignContest(model));
      isOpen = isOpen || (model.urgencyCode &&
        model.urgencyCode.identifier === 'E<>CLASEEXPTE')
      return isOpen;
    }
    return false;
  }

  private static isDesignContest(model: any) {
    if (model.type) {
      let isDesignContest =
        model.type &&
        model.type.identifier !== undefined &&
        model.type.identifier === 'CP<>PROCEDIMIENTOSCONTRA';
      return isDesignContest;
    }
    return false;
  }

  private static isNegotiated(model: any) {
    if (model.type) {
      let isNegotiated = model.type.identifier === 'N<>PROCEDIMIENTOSCONTRA';
      if (model.type.properties) {
        isNegotiated =
          isNegotiated || model.type.properties['MODO'] === 'N'
      }
      return isNegotiated;
    }
    return false;
  }


  private static isCompetitiveDialogue(model: any) {
    if (model.type) {
      let isCompetitiveDialogue =
        model.type &&
        model.type.identifier !== undefined &&
        model.type.identifier === 'DC<>PROCEDIMIENTOSCONTRA';
      return isCompetitiveDialogue;
    }
    return false;
  }

  private static isTenderWithNegotiation(model: any) {
    if (model.type) {
      let isTenderWithNegotiation =
        model.type &&
        model.type.identifier !== undefined &&
        model.type.identifier === 'LN<>PROCEDIMIENTOSCONTRA';
      if (model.type.properties) {
        isTenderWithNegotiation =
          isTenderWithNegotiation || model.type.properties['MODO'] === 'LN'
      }
      return isTenderWithNegotiation;
    }
    return false;
  }

  private static isNegotiatedWithoutPublicity(model: any) {
    if (model.type) {
      let isNegotiatedWithoutPublicity =
        model.type &&
        model.type.identifier !== undefined &&
        model.type.identifier === 'NSP<>PROCEDIMIENTOSCONTRA';
      if (model.type.properties) {
        isNegotiatedWithoutPublicity =
          isNegotiatedWithoutPublicity || model.type.properties['MODO'] === 'NSP'
      }

      return isNegotiatedWithoutPublicity;
    }
    return false;
  }

  private static isRestrictedContrat(model: any) {
    if (model.type) {
      let isModesRestricted =
        model.type.identifier === 'R<>PROCEDIMIENTOSCONTRA';
      if (model.type.properties) {
        isModesRestricted =
          isModesRestricted || model.type.properties['MODO'] === 'R'
      }
      let isRestricted = isModesRestricted;
      return isRestricted;
    }
    return false;
  }

  // si es base en acuerdo marco: [esAdjAcuerdoMarco=modoProc.equals("AAM")]
  private static isBasedFrameworkAgreement(model: any) {
    if (model.type) {
      let isModesBasedFrameworkAgreement =
        model.type.identifier !== undefined &&
        model.type.identifier === 'AAM<>PROCEDIMIENTOSCONTRA';
      if (model.type.properties) {
        isModesBasedFrameworkAgreement =
          isModesBasedFrameworkAgreement || model.type.properties['MODO'] === 'AAM'
      }
      return isModesBasedFrameworkAgreement !== undefined
        ? isModesBasedFrameworkAgreement
        : false;
    }
    return false;
  }

  private static isAssociationForInnovation(model: any) {
    if (model.type) {
      let isAssociationForInnovation =
        model.type &&
        model.type.identifier !== undefined &&
        model.type.identifier === 'API<>PROCEDIMIENTOSCONTRA';
      return isAssociationForInnovation;
    }
    return false;
  }

  public static isAM(model: any) {
    let isAM = false;
    if (model.complementarySystem) {
      isAM = model.complementarySystem
        && model.complementarySystem.identifier === 'AM<>SISTCOMPLEMENTARIO';
    }
    return isAM;
  }

  public static isCBAM(model: any) {
    let isCBAM = false;
    if (model.complementarySystem) {
      isCBAM = model.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';
    }
    return isCBAM;
  }

  public static isCSDA(model: any) {
    let isCSDA = false;
    if (model.complementarySystem) {
      isCSDA = model.complementarySystem.identifier === 'CSDA<>SISTCOMPLEMENTARIO';
    }
    return isCSDA;
  }

  public static isServices(model: any) {
    let isServices = false;
    if (model.typeCode) {
      isServices = (model.typeCode.identifier === '04<>TIPOEXPTE');
    }
    return isServices;
  }

  private static isWorks(model: any) {
    let isWorks = false;
    if (model.typeCode) {
      isWorks = (model.typeCode.identifier === '01<>TIPOEXPTE');
    }
    return isWorks;
  }

  private static isGoods(model: any) {
    let isGoods = false;
    if (model.typeCode) {
      isGoods = (model.typeCode.identifier === '02<>TIPOEXPTE');
    }
    return isGoods;

  }

  public static isEntityPanap(model: any) {
    let isPanap = false;
    if (model.context && model.context.configurations && model.context.configurations.isPanap) {
      isPanap = model.context.configurations.isPanap.value;
    }
    return isPanap;
  }

  public static isEntityNoPanap(model: any) {
    let isPanap = false;
    if (model.context && model.context.configurations && model.context.configurations.isNoPanap) {
      isPanap = model.context.configurations.isNoPanap.value;
    }
    return isPanap;
  }


  public static visibleGoods(model: any) {
    let result = false;
    if (model.ui.typeCode) {
      result = model.ui.typeCode.identifier === '02<>TIPOEXPTE';
    }
    return result;
  }

  private static isNoTax(model: any) {
    let noTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier === '0<>TIPO_IMPUESTO');
    return noTax;
  }

  private static isNoTaxByType(model: any) {
    let noTax = (model.taxType &&
      model.taxType.identifier === '0<>TIPO_IMPUESTO');
    return noTax;
  }

  private static isEmergency(model: any) {
    let resultado = false;
    if (model.urgencyCode &&
      model.urgencyCode.identifier === 'E<>CLASEEXPTE') {
      resultado = true;
    }
    return resultado;
  }

  constructor() { }

  public noVisibleMinorAndCBAM(model: any) {
    if (ContractValidations.isMinorContrat(model.ui) || ContractValidations.isCBAM(model.ui)) {
      return false;
    } else {
      return true
    }
  }

  public isIncome(model: any) {
    let result = false;
    if (model.ui && model.ui.accountingMotivation
      && model.ui.accountingMotivation.identifier === '2<>TIPO_MOTIVACION_CONTABLE') {
      result = true;
    }
    return result;
  }

  public noVisibleMinor(model: any) {
    if (ContractValidations.isMinorContrat(model.ui)) {
      return false;
    } else {
      return true
    }
  }


  public noVisibleEntityNoPanap(model: any) {
    if (ContractValidations.isEntityNoPanap(model.dto)) {
      return false;
    } else {
      return true;
    }
  }

  public noVisibleEntityPanapAndNoPanap(model: any) {
    if (ContractValidations.isEntityNoPanap(model.dto) || ContractValidations.isEntityPanap(model.dto)) {
      return false;
    } else {
      return true;
    }
  }

  public visibleAM(model: any) {
    if (ContractValidations.isAM(model.ui)) {
      return true;
    } else {
      return false;
    }
  }

  public noVisibleAM(model: any) {
    if (ContractValidations.isAM(model.ui)) {
      return false;
    } else {
      return true;
    }
  }

  public noVisibleAMTable(model: any) {
    if (ContractValidations.isAM(model._parent.ui)) {
      return false;
    } else {
      return true;
    }
  }

  public noVisibleEntityPanapAndNoPanapTable(model: any) {
    if (ContractValidations.isEntityNoPanap(model._parent.dto) || ContractValidations.isEntityPanap(model._parent.dto)) {
      return false;
    } else {
      return true;
    }
  }

  public visibleCBAM(model: any) {
    if (ContractValidations.isCBAM(model.ui)) {
      return true;
    } else {
      return false;
    }
  }


  public noVisibleCBAM(model: any) {
    if (ContractValidations.isCBAM(model.ui)) {
      return false;
    } else {
      return true;
    }
  }

  public visibleCSDA(model: any) {
    if (ContractValidations.isCSDA(model.ui)) {
      return true;
    } else {
      return false;
    }
  }


  public visibleGeneral(model: any) {
    if (ContractValidations.isCSDA(model.ui) || ContractValidations.isCBAM(model.ui) || ContractValidations.isAM(model.ui) ||
      ContractValidations.isMinorContrat(model.ui)) {
      return false;
    } else {
      return true;
    }
  }

  public noVisibleAMAndMinor(model: any) {
    if (ContractValidations.isAM(model.ui) || ContractValidations.isMinorContrat(model.ui)) {
      return false;
    } else {
      return true;
    }
  }

  public visibleAMAndMinor(model: any) {
    if (ContractValidations.isAM(model.ui) || ContractValidations.isMinorContrat(model.ui)) {
      return true;
    } else {
      return false;
    }
  }


  public visibleMinor(model: any) {
    if (ContractValidations.isMinorContrat(model.ui)) {
      return true;
    } else {
      return false;
    }
  }

  public noVisibleCBAMIfNotSeconBinding(model: any) {
    let result = true;
    if (ContractValidations.isCBAM(model.ui)) {
      if (!model.dto.secondBindigCB || (model.dto.secondBindigCB && ContractValidations.isWithOutSecondBinding(model.dto.secondBindigCB))) {
        result = false;
      }
    }
    return result;
  }

  public onlyVisibleServicesAndHarmonizedRegulation(model: any) {
    let result = false;
    if (ContractValidations.isServices(model.ui)
      && model.dto.contractClassification && model.dto.contractClassification.harmonizedRegulation) {
      result = true;
    }
    return result;
  }

  public visibleApportioned(model: any) {
    let result = false;
    if (model.ui.apportioned && model.ui.apportioned) {
      result = true;
    }
    return result;
  }



  public visibleServices(model: any) {
    let result = false;
    if (model.ui.typeCode) {
      result = model.ui.typeCode.identifier === '04<>TIPOEXPTE';
    }
    return result;
  }

  public visibleGoods(model: any) {
    let result = false;
    if (ContractValidations.visibleGoods(model)) {
      result = true;
    }
    return result;
  }

  public visibleWorksAndServices(model: any) {
    let result = false;
    if (ContractValidations.isWorks(model.ui) || ContractValidations.isServices(model.ui)) {
      result = true;
    }
    return result;
  }

  public isVisibleWorks(model: any) {
    let result = false;
    if (ContractValidations.isWorks(model.ui)) {
      result = true;
    }
    return result;
  }


  public isVisibleIncome(model: any) {
    let result = false;
    if (model.ui && model.ui.accountingMotivation
      && model.ui.accountingMotivation.identifier === '2<>TIPO_MOTIVACION_CONTABLE') {
      result = true;
    }
    return result;
  }

  public isVisibleIncomeTable(model: any) {
    let result = false;
    if (model._parent && model._parent.ui && model._parent.ui.accountingMotivation !== undefined && model._parent.ui.accountingMotivation
      && model._parent.ui.accountingMotivation.identifier === '2<>TIPO_MOTIVACION_CONTABLE') {
      result = true;
    }
    return result;
  }

  // Habilitar: Tipo Impositivo
  public enabledTaxRate(model: any) {
    let noTax = ContractValidations.isNoTax(model);
    return !noTax;
    /*if (!noTax) {
      return true;
    }
    return false;*/
  }


  public enabledTaxRateAward(model: any) {
    let noTax = ContractValidations.isNoTaxByType(model.dto.budget.awardAmount);
    return !noTax;
  }

  public enabledTaxRateTender(model: any) {
    let noTax = ContractValidations.isNoTaxByType(model.dto.budget.tenderingAmount);
    return !noTax;
  }

  public isVisibleCBAMSeconBindig(model: any) {
    let result = true;
    /*
      6. CBAM. Visible  Si SEGUNDA_LICITACION_CB = Con segunda licitación
    */
    if (ContractValidations.isCBAM(model.ui) && model.dto.secondBindigCB
      && !ContractValidations.isWithSecondBinding(model.dto.secondBindigCB)) {
      result = false;
    }
    return result;
  }
  public isVisibleInvitationNumber(model: any) {
    let result = false;
    /*
    El Número de empresas invitadas a licitar introducidas en la FE.
    Visible en procedimientos:
      1. Licitación con Negociación
      2. Negociados sin Publicidad
      3. Restringidos
      4. Menor
      5. Dialogo Competitivo
      6. CBAM. Visible  Si SEGUNDA_LICITACION_CB = Con segunda licitación
      6.1. UI-Electrónico: Como hasta ahora
      6.2. UI-Papel y UE-Externo
      6.2.1 Se carga el FICHAREG_AM.TOTAL_ADJS
    */
    if ((ContractValidations.isMinorContrat(model.ui) && (!model.dto.minorTenderType || model.dto.minorTenderType
      && model.dto.minorTenderType.identifier !== '0<>TIPO_LICITACION_MENOR'))
      || ContractValidations.isCompetitiveDialogue(model.ui)
      || ContractValidations.isTenderWithNegotiation(model.ui) || ContractValidations.isNegotiatedWithoutPublicity(model.ui)
      || ContractValidations.isRestrictedContrat(model.ui)) {
      result = true;
    }

    if (ContractValidations.isCBAM(model.ui) && model.dto.secondBindigCB
      && (ContractValidations.isWithSecondBinding(model.dto.secondBindigCB)
        || ContractValidations.isAutomaticBinding(model.dto.secondBindigCB))) {
      result = true;
    }

    if (ContractValidations.isCSDA(model.ui)) {
      result = true;
    }
    return result;
  }

  public isVisibleAwardMethod(model: any) {
    let result = true;
    /*Visible excepto en los procedimientos:
      Negociación con licitación
      Negociado sin publicida
      Asociación para la innovación. */
    if (ContractValidations.isNegotiatedWithoutPublicity(model.ui) || ContractValidations.isAssociationForInnovation(model.ui)
      || ContractValidations.isTenderWithNegotiation(model.ui)) {
      result = false;
    }
    return result;

  }

  public isVisibleFinalWarranty(model: any) {
    let result = true;

    /*No visible Menores y sistemas homologados*/
    if (ContractValidations.isMinorContrat(model.ui) || ContractValidations.isHomologationSystem(model.ui)) {
      result = false;
    }
    /*
    1. Si CBAM
      1.1. Si FICHAREPLYCA.CB_GARANTIADEF=SI -> Visible
    2. Si AM
      2.1. Si FICHAREPLYCA.AM_GAR_DEFINITIVA es "No procede garantía definitiva" -> NO Visible
      2.2. Si FICHAREPLYCA.AM_GAR_DEFINITIVA es "En Acuerdo Marco" -> Visible
      2.3. Si FICHAREPLYCA.AM_GAR_DEFINITIVA es "En Contrato Basado" -> NO Visible
      2.4. Si FICHAREPLYCA.AM_GAR_DEFINITIVA es "Dual" -> Visible
    3. Resto
    3.1. Siempre visible
*/
    if (ContractValidations.isCBAM(model.ui) || ContractValidations.isCSDA(model.ui)) {
      if (model.dto.budget && model.dto.budget.finalFinancialGuaranteeAAM) {
        result = true;
      } else {
        result = false;
      }
    }

    if (ContractValidations.isAM(model.ui)) {
      if (model.dto.procurementProjectInfo && model.dto.procurementProjectInfo.definitiveGuarantee &&
        (model.dto.procurementProjectInfo.definitiveGuarantee.identifier === '3<>TIPO_GARANTIA_AM' ||
          model.dto.procurementProjectInfo.definitiveGuarantee.identifier === '1<>TIPO_GARANTIA_AM')) {
        result = false;
      } else {
        result = true;
      }
    }
    return result;

  }

  public isVisibleApprovalAwardDate(model: any) {
    let result = true;
    if (ContractValidations.isEntityNoPanap(model.dto) || ContractValidations.isEntityPanap(model.dto)) {
      result = false;
    }
    if (ContractValidations.isAM(model.ui) || ContractValidations.isMinorContrat(model.ui) || ContractValidations.isHomologationSystem(model.ui)) {
      result = false;
    }
    if (ContractValidations.isCBAM(model.ui) && (!model.dto.secondBindigCB || (model.dto.secondBindigCB
      && !ContractValidations.isWithSecondBinding(model.dto.secondBindigCB)))) {
      result = false;
    }
    if (model.ui.accountingMotivation
      && model.ui.accountingMotivation.identifier === '2<>TIPO_MOTIVACION_CONTABLE') {
      result = false;
    }
    return result;
  }
  // Visibilidad de la clausula de prorroga
  public isVisibleExtension(model: any) {
    if (ContractValidations.isMinorContrat(model.ui) || ContractValidations.isCBAM(model.ui) || ContractValidations.isHomologationSystem(model.ui)) {
      return false;
    }
    if (ContractValidations.isCSDA(model.ui)) {
      return true;
    }
    if (ContractValidations.isWorks(model.ui)) {
      if (ContractValidations.isAM(model.ui)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }

  }

  public isVisibleApprovalAwardDateMinor(model: any) {
    let result = false;
    // Si FICHAREG.CLASEEXPTEID = "Emergencia" -> Ocultar
    // Visible solo para CBAM Si SEGUNDA_LICITACION_CB = sin Segunda Licitación.
    if (ContractValidations.isMinorContrat(model.ui)
      || ContractValidations.isCBAM(model.ui) && model.dto.secondBindigCB
      && (ContractValidations.isWithOutSecondBinding(model.dto.secondBindigCB)
        || ContractValidations.isAutomaticBinding(model.dto.secondBindigCB))) {
      result = true;
    }
    if (model.ui.accountingMotivation
      && model.ui.accountingMotivation.identifier === '2<>TIPO_MOTIVACION_CONTABLE') {
      result = false;
    }
    return result;
  }

  // El importe de la baja de adjudicación = pbl sin iva – importe de adjudicación sin iva
  // El cálculo sería = importe de la baja de adjudicación / pbl %
  public valueAwardCancellationPercentage(model: any) {
    let resultado = 1;
    if (model.dto.budget
      && model.dto.budget.awardAmount && model.dto.budget.awardAmount.amountExcludingTaxes
      && model.dto.budget.awardAmount && model.dto.budget.awardAmount.amountExcludingTaxes !== 0.0
      && model.dto.budget.tenderingAmount && model.dto.budget.tenderingAmount.amountExcludingTaxes
      && model.dto.budget.tenderingAmount && model.dto.budget.tenderingAmount.amountExcludingTaxes !== 0.0) {
      let amountAwardCancellation = (model.dto.budget.tenderingAmount.amountExcludingTaxes -
        model.dto.budget.awardAmount.amountExcludingTaxes);
      resultado = (amountAwardCancellation / model.dto.budget.tenderingAmount.amountExcludingTaxes) * 100;
    }

    return resultado;
  }



  public valueRegisterSystemAM(model: any) {
    if (model.dto.originalContractingSystemID && model.dto.originalContractingSystemID.isProjectReplyca) {
      return 'REPLYCA';
    } else {
      return 'RECO';
    }

  }

  public isvisibleComplementarySystem(model: any) {

    return (
      (ContractValidations.isOpenContrat(model.ui) ||
        ContractValidations.isNegotiated(model.ui) ||
        ContractValidations.isTenderWithNegotiation(model.ui) ||
        ContractValidations.isNegotiatedWithoutPublicity(model.ui) ||
        ContractValidations.isRestrictedContrat(model.ui) ||
        ContractValidations.isBasedFrameworkAgreement(model.ui)) &&
      (ContractValidations.isWorks(model.ui) ||
        ContractValidations.isGoods(model.ui) ||
        ContractValidations.isServices(model.ui))
    );


    return false;
  }

  public noVisibleHomologationSystem(model: any) {
    if (ContractValidations.isHomologationSystem(model.ui)) {
      return false;
    } else {
      return true;
    }
  }

  public visibleHomologationSystem(model: any) {
    if (ContractValidations.isHomologationSystem(model.ui)) {
      return true;
    } else {
      return false;
    }
  }

  public noVisibleEmergency(model: any) {
    let result = true;
    if (ContractValidations.isEmergency(model.ui)) {
      result = false;
    }
    return result;
  }

  public visibleEmergency(model: any) {
    let result = false;
    if (ContractValidations.isEmergency(model.ui)) {
      result = true;
    }
    return result;
  }

  public isVisibleJustificationNegotiated(model: any) {
    let result = false;
    if (ContractValidations.isTenderWithNegotiation(model.ui) || ContractValidations.isNegotiatedWithoutPublicity(model.ui)) {
      result = true;
    }
    return result;
  }


  public isVisibleAuditAwardDate(model: any) {
    let resultado1;
    if (ContractValidations.isEntityNoPanap(model.dto) || ContractValidations.isEntityPanap(model.dto)) {
      resultado1 = false;
    } else {
      resultado1 = true;
    }
    let resultado2;
    if (ContractValidations.isCSDA(model.ui) || ContractValidations.isCBAM(model.ui) || ContractValidations.isAM(model.ui) ||
      ContractValidations.isMinorContrat(model.ui) || ContractValidations.isHomologationSystem(model.ui)) {
      resultado2 = false;
    } else {
      resultado2 = true;
    }
    let resultado3 = true;
    if (model.ui.accountingMotivation
      && model.ui.accountingMotivation.identifier === '2<>TIPO_MOTIVACION_CONTABLE') {
      resultado3 = false;
    }
    let resultado4 = true;
    if (ContractValidations.isEmergency(model.ui)) {
      resultado4 = false;
    }
    let resultado = resultado1 && resultado2 && resultado3 && resultado4;
    return resultado;
  }

  public isEditableRevisionPrice(model: any) {
    let result = true;
    if (ContractValidations.isServices(model.ui) || ContractValidations.isGoods(model.ui)) {
      result = false;
    }
    return result;
  }

  public visibleAwardCancellationPercentage(model: any) {
    let resultado = true;

    if (ContractValidations.isAM(model.ui)) {
      resultado = false;
    }
    if (ContractValidations.isMinorContrat(model.ui)) {
      resultado = false;
    }
    if (ContractValidations.isHomologationSystem(model.ui)) {
      resultado = false;
    }
    if (model.ui.accountingMotivation
      && model.ui.accountingMotivation.identifier === '2<>TIPO_MOTIVACION_CONTABLE') {
      resultado = false;
    }
    if (ContractValidations.isCBAM(model.ui)) {
      if (model.dto.secondBindigCB && !ContractValidations.isWithSecondBinding(model.dto.secondBindigCB)
        && !ContractValidations.isAutomaticBinding(model.dto.secondBindigCB)) {
        resultado = false;
      }
    }

    return resultado;
  }

  public valueContractTitle(model: any) {
    if (ContractValidations.isMinorContrat(model.ui) || ContractValidations.isCBAM(model.ui)) {
      return model.dto.procurementProjectInfo.title;
    } else {
      if (model.ui.apportioned) {
        return model.dto.contractLots[0].lot.description;
      } else {
        return model.dto.procurementProjectInfo.abbreviatedTitle;
      }

    }

  }

  public editableNumberAwards(model: any) {
    // Habilitado cuando segunda licitación sea: Con segunda Licitación o Dual
    if (model.dto.secondBindigAM && (ContractValidations.isWithSecondBinding(model.dto.secondBindigAM)
      || ContractValidations.isMixedBinding(model.dto.secondBindigAM))) {
      return true;
    }
    return false;
  }

  public setValue_PymeContractTender(model: any) {
    //Valores del customField: 1 = si, 2 = no, 0 = Sin valor
    if (model && model.tenderer.customFields && model.tenderer.customFields.EMP_ES_PYME_STD && 
      model.tenderer.customFields.EMP_ES_PYME_STD.identifier && model.tenderer.customFields.EMP_ES_PYME_STD.identifier !== '0<>nulo') {
      model.pyme = model.tenderer.customFields.EMP_ES_PYME_STD.identifier === '1<>nulo';
    } else {
      model.pyme = undefined;
    }
  }

  public valueFilterReservedType(model: any) {
    let filter = 'NULO';
    if (model.ui.isAutomaticMode) {
      let exp_Instruccion_1_2022 = model.dto.division?.project?.exp_Instruccion_1_2022;
      let isReserved = model.dto.contractClassification?.reservedContract;
      if (isReserved && exp_Instruccion_1_2022) {
        let isApportioned = model.dto.division.project.breakdownLot.apportioned;
        let procurementProjectLot = undefined;
        let reservedType = undefined;
        if (isApportioned) {
          let contractLotId = model.dto.contractLots[0].lot.lotId;
          model.dto.division.project.breakdownLot.lots.forEach(projectLot => {
            if (projectLot.lotId === contractLotId) {
              procurementProjectLot = projectLot;
              isReserved = procurementProjectLot.extLotIsReservedContract;
              reservedType =
                reservedType = procurementProjectLot.extLotReservedContractType?.properties?.ID_TIPO_CONT_RESERVADO;
            }
          });
        } else {
          procurementProjectLot = model.dto.division.project;
          isReserved = procurementProjectLot.characteristicsContractObject?.isReservedContract;
          reservedType = procurementProjectLot.characteristicsContractObject?.reservedContractType?.properties?.ID_TIPO_CONT_RESERVADO;
        }
        if (isReserved && reservedType !== undefined) {
          let typeProperty = model.ui?.reservedEntityType1_2022_Aymad;
          if (reservedType.toString() === typeProperty.toString()) {
            filter = typeProperty;
          }
        }
      }
    }
    return filter;
  }

  public editableReservedContractType(model: any) {
    let editable = false;
    if (model.ui.isAutomaticMode) {
      let exp_Instruccion_1_2022 = model.dto.division?.project?.exp_Instruccion_1_2022;
      let isReserved = model.dto.contractClassification?.reservedContract;
      if (isReserved && exp_Instruccion_1_2022) {
        let isApportioned = model.dto.division.project.breakdownLot.apportioned;
        let procurementProjectLot = undefined;
        let reservedType = undefined;
        if (isApportioned) {
          let contractLotId = model.dto.contractLots[0].lot.lotId;
          model.dto.division.project.breakdownLot.lots.forEach(projectLot => {
            if (projectLot.lotId === contractLotId) {
              procurementProjectLot = projectLot;
              isReserved = procurementProjectLot.extLotIsReservedContract;
              reservedType =
                reservedType = procurementProjectLot.extLotReservedContractType?.properties?.ID_TIPO_CONT_RESERVADO;
            }
          });
        } else {
          procurementProjectLot = model.dto.division.project;
          isReserved = procurementProjectLot.characteristicsContractObject?.isReservedContract;
          reservedType = procurementProjectLot.characteristicsContractObject?.reservedContractType?.properties?.ID_TIPO_CONT_RESERVADO;
        }
        if (isReserved && reservedType !== undefined) {
          let typeProperty = model.ui?.reservedEntityType1_2022_Aymad;
          if (reservedType.toString() === typeProperty.toString()) {
            editable = !model.ui.isAnulationMode;
          }
        }
      }
    } else {
      editable = !model.ui.isEditableSupport && !model.ui.isAnulationMode;
    }
    return editable;
  }

  //Campo tipo de subcontratacion aymad.
  public visibleOutosourcingTypeGeneral(model: any) {
    let exp_Instruccion_1_2022 = model.dto.division?.project?.exp_Instruccion_1_2022;
    let isAutomaticMode = model.ui.isAutomaticMode;
    let isReserved = model.dto.contractClassification?.reservedContract;
    let isCBAM = model.ui?.complementarySystem !== undefined && model.ui?.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';
    let visible = false;
    if (!isAutomaticMode || (exp_Instruccion_1_2022 && isReserved)) {
      if (isCBAM && isAutomaticMode) {
        let projectOutsourcingType = model?.dto?.division?.project?.outsourcingType;
        if (projectOutsourcingType !== undefined && projectOutsourcingType.identifier !== undefined) {
          let idType = projectOutsourcingType.identifier.toString().substring(0, projectOutsourcingType.identifier.indexOf('<>'));
          let typeProperty = model.ui?.outSourcingType1_2022_Aymad;
          if (typeProperty.toString() !== idType.toString()) {
            visible = true;
          } else {
            visible = false;
          }
        }
      } else {
        // No basados, o basados manuales.
        visible = model.dto?.tenderByContractor !== undefined && model.dto?.tenderByContractor;
      }
    }
    return visible;
  }

  public editableOutsourcingTypeGeneral(model: any) {
    let exp_Instruccion_1_2022 = model.dto.division?.project?.exp_Instruccion_1_2022;
    let isAutomaticMode = model.ui.isAutomaticMode;
    let isReserved = model.dto.contractClassification?.reservedContract;
    let isCBAM = model.ui?.complementarySystem !== undefined && model.ui?.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';
    let editable = false;
    if (!isAutomaticMode || (exp_Instruccion_1_2022 && isReserved)) {
      if (isCBAM && isAutomaticMode) {
        let projectOutsourcingType = model?.dto?.division?.project?.outsourcingType;
        if (projectOutsourcingType !== undefined && projectOutsourcingType.identifier !== undefined) {
          let idType = projectOutsourcingType.identifier.toString().substring(0, projectOutsourcingType.identifier.indexOf('<>'));
          let typeProperty = model.ui?.outSourcingType1_2022_Aymad;
          if (typeProperty.toString() !== idType.toString()) {
            editable = false;
          } else {
            editable = true;
          }
        }
      } else {
        // No basados, o basados manuales.
        let tenderByContractor = model.dto?.tenderByContractor !== undefined && model.dto?.tenderByContractor;
        editable = tenderByContractor && !model.ui.isEditableSupport && !model.ui.isAnulationMode;
      }
    }
    return editable;
  }

  //Para basados, automáticos, con tipo de la FRC del Am = 2.
  public visibleOutosourcingTypeBasedContract(model: any) {
    let visible = false;
    let exp_Instruccion_1_2022 = model.dto.division?.project?.exp_Instruccion_1_2022;
    let isAutomaticMode = model.ui.isAutomaticMode;
    let isReserved = model.dto.contractClassification?.reservedContract;
    let isCBAM = model.ui?.complementarySystem !== undefined && model.ui?.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';
    if (exp_Instruccion_1_2022 && isReserved) {
      if (isCBAM && isAutomaticMode) {
        let projectOutsourcingType = model?.dto?.division?.project?.outsourcingType;
        if (projectOutsourcingType !== undefined && projectOutsourcingType.identifier !== undefined) {
          let idType = projectOutsourcingType.identifier.toString().substring(0, projectOutsourcingType.identifier.indexOf('<>'));
          let typeProperty = model.ui?.outSourcingType1_2022_Aymad;
          if (typeProperty.toString() === idType.toString()) {
            visible = true;
          } else {
            visible = false;
          }
        }
      }
    }
    return visible;
  }

  //Si no es automatico, y es un basado --> Si el AM no es reservado, no tiene que ser editable.
  public editableReservedContract(model: any) {
    let editable = true;
    let isAutomaticMode = model.ui.isAutomaticMode;
    let isCBAM = model.ui?.complementarySystem !== undefined && model.ui?.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';
    if (!isAutomaticMode && isCBAM) {
      editable = model.dto.originalContractingSystemID?.contractClassification && model.dto.originalContractingSystemID?.contractClassification?.reservedContract;
    }
    editable = editable && (model.ui && (!model.ui.isAutomaticMode || model.ui.isEditableSupport) && !model.ui.isAnulationMode);
    return editable;
  }

  public loadOrganizationalSnapshotData(model: any) {
    //Limpiamos los datos de la pantalla
    /*model.dto.organizationalInfo.contractPromoterUnit.name = '';
    model.dto.organizationalInfo.contractPromoterUnit.identifier = undefined;
    model.dto.organizationalInfo.contractingUnit.identifier = undefined;
    model.dto.organizationalInfo.contractingUnit.name = '';
    model.dto.organizationalInfo.contractingAuthority.identifier = undefined;
    model.dto.organizationalInfo.contractingAuthority.name = '';
    model.dto.organizationalInfo.centerSectionCode.description = undefined;
    model.dto.organizationalInfo.centerSectionCode.identifier = undefined;*/
    model.dto.organizationalInfo.contractingUnit = undefined;
    model.dto.organizationalInfo.contractingAuthority = undefined;
    model.dto.organizationalInfo.centerSectionCode = undefined;
    model.dto.organizationalInfo.contractPromoterUnit = undefined;

    //Si hemos seleccionado valor en el combo. Si no tiene valor viene con undefined o con null....¿?¿?
    if (model.dto.previousOrganizationalUnitRegistration !== undefined && model.dto.previousOrganizationalUnitRegistration !== null) {
      if (model.dto.previousOrganizationalUnitRegistration) {
        //Se ha seleccionado SI. Comprobamos si tiene cargado el origen (ya viene de servidor con todo ok). Si no, no cargamos nada, tienen que buscarlo.
        if (model.dto.organizationalInfoOrigin !== undefined) {
          model.dto.organizationalInfo = JSON.parse(JSON.stringify(model.dto.organizationalInfoOrigin));
        }
      } else {
        //Se ha seleccinado NO. Cargamos el ultimo destino. Ya viene de servidor con todo ok.
        model.dto.organizationalInfo = JSON.parse(JSON.stringify(model.dto.organizationalInfoLastDestination));
      }
      model.ui.selectedOrganizationalInfo = model.dto.organizationalInfo;
    }
  }

  //Se ha seleccionado el hito desde el buscador porque existe mas de un origen
  public changeProjectOrganizationalSnapshot(model: any) {
    if (model.ui.activeTemporayPeriodOrganizationalChange) {
      if (model.ui.selectedOrganizationalInfo) {
        model.dto.organizationalInfo.contractingUnit = <MasterDataDTO>{
          identifier: model.ui.selectedOrganizationalInfo.content.UD_CONTRATADORA_ID.value,
          description: model.ui.selectedOrganizationalInfo.content.UD_CONTRATADORA_DESCRIP.value
        };
        model.dto.organizationalInfo.contractingUnit.name = model.dto.organizationalInfo.contractingUnit.description;

        model.dto.organizationalInfo.contractPromoterUnit = <MasterDataDTO>{
          identifier: model.ui.selectedOrganizationalInfo.content.UD_PROMOTORA_ID.value,
          description: model.ui.selectedOrganizationalInfo.content.UD_PROMOTORA_DESCRIP.value
        };
        model.dto.organizationalInfo.contractPromoterUnit.name = model.dto.organizationalInfo.contractPromoterUnit.description;

        model.dto.organizationalInfo.contractingAuthority = <MasterDataDTO>{
          identifier: model.ui.selectedOrganizationalInfo.content.ORG_CONTRATACION_ID.value,
          description: model.ui.selectedOrganizationalInfo.content.ORG_CONTRATACION_DESCRIP.value
        };
        model.dto.organizationalInfo.contractingAuthority.name = model.dto.organizationalInfo.contractingAuthority.description;

        model.dto.organizationalInfo.centerSectionCode = <MasterDataDTO>{
          identifier: model.ui.selectedOrganizationalInfo.content.CENTRO_GESTOR_ID.value,
          description: model.ui.selectedOrganizationalInfo.content.CENTRO_GESTOR_DESCRIP.value
        };
        /*model.dto.organizationalInfo.contractingUnit.name = model.ui.selectedOrganizationalInfo.content.UD_CONTRATADORA_DESCRIP.value;
        model.dto.organizationalInfo.contractingUnit.identifier = model.ui.selectedOrganizationalInfo.content.UD_CONTRATADORA_ID.value;
        model.dto.organizationalInfo.contractPromoterUnit.name = model.ui.selectedOrganizationalInfo.content.UD_PROMOTORA_DESCRIP.value;
        model.dto.organizationalInfo.contractPromoterUnit.identifier = model.ui.selectedOrganizationalInfo.content.UD_PROMOTORA_ID.value;
        model.dto.organizationalInfo.contractingAuthority.name = model.ui.selectedOrganizationalInfo.content.ORG_CONTRATACION_DESCRIP.value;
        model.dto.organizationalInfo.contractingAuthority.identifier = model.ui.selectedOrganizationalInfo.content.ORG_CONTRATACION_ID.value;
        model.dto.organizationalInfo.centerSectionCode.description = model.ui.selectedOrganizationalInfo.content.CENTRO_GESTOR_DESCRIP.value;
        model.dto.organizationalInfo.centerSectionCode.identifier = model.ui.selectedOrganizationalInfo.content.CENTRO_GESTOR_ID.value;*/
      } else {
        //La unidad promotora no tiene valor.
        /*model.dto.organizationalInfo.contractingUnit.name = '';
        model.dto.organizationalInfo.contractingUni.identifier = '';
        model.dto.organizationalInfo.contractingAuthority.identifier = undefined;
        model.dto.organizationalInfo.contractingAuthority.name = '';
        model.dto.organizationalInfo.contractPromoterUnit.name = '';
        model.dto.organizationalInfo.contractPromoterUnit.identifier = undefined;;
        model.dto.organizationalInfo.centerSectionCode.description = undefined;
        model.dto.organizationalInfo.centerSectionCode.identifier = undefined;*/
        model.dto.organizationalInfo.contractingUnit = undefined;
        model.dto.organizationalInfo.contractingAuthority = undefined;
        model.dto.organizationalInfo.contractPromoterUnit = undefined;
        model.dto.organizationalInfo.centerSectionCode = undefined;
      }
    }
  }

  public visiblePreviousOrganizationalUnitRegistration(model: any) {
    let externalUnitAM = model.dto.externalUnitAM;
    let activeTemporayPeriodOrganizationalChange = model.ui.activeTemporayPeriodOrganizationalChange;
    return !externalUnitAM && (activeTemporayPeriodOrganizationalChange || (!activeTemporayPeriodOrganizationalChange && model.dto.previousOrganizationalUnitRegistration !== undefined));
  }


}
